module.exports = __webpack_public_path__ + "static/media/signup-forward-arrow.506e9486.svg";